<template>
  <v-layout v-if="commercialZone">
    <v-container fluid pa-0 flat>
      <v-layout wrap row justify-center>
        <v-flex xs12 pa-0>
          <v-card tile flat>
            <v-toolbar
              dark
              flat
              dense
              color="theme_primary_lighten1"
              class="white--text"
              align-center
            >
              <v-icon small pa-0 color="white">edit</v-icon>
              <v-text-field
                label="Name"
                @change="updateCommercialZone"
                v-model="commercialZone.name"
                flat
                solo
                required
                background-color="transparent"
              />
              <v-spacer></v-spacer>

              <destroyModale
                color="white"
                :fab="false"
                :flat="true"
                small
                show_label
                resourceName="commercial_zone"
                :itemId="commercialZone.id"
                warningText="You are going to remove the Commercial Zone and its associated products permanently."
              />
            </v-toolbar>

            <v-layout wrap justify-center row fill-height pa-4>
              <v-flex>
                <v-autocomplete
                  class="country-autocomplete"
                  :items="countries"
                  item-value="id"
                  item-text="name"
                  @change="updateCommercialZone"
                  v-model="commercialZone.country_ids"
                  background-color="white"
                  solo
                  multiple
                  chips
                  flat
                  round
                  hide-selected
                  :allow-overflow="false"
                  single-line
                  prepend-inner-icon="public"
                  deletable-chips
                  placeholder="Countries"
                  label="Countries"
                />
              </v-flex>
              <v-flex pa-2 xs12 sm12 md12>
                <commercial-product-data-list :zone-id="zoneId" />
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import UPDATE_COMMERCIAL_ZONE from "../../graphql/commercial_zones/update.gql";
import commercialProductDataList from "./commercialProductDataList";

export default {
  components: {
    commercialProductDataList,
  },
  data() {
    return {
      zoneId: "",
      dialog: false,
      commercialZone: {},
    };
  },
  computed: {
    ...mapGetters("commonStore", ["countries"]),
    ...mapGetters("commercialStore", [
      "companyContactId",
      "getCommercialZoneById",
      "commercialZones",
    ]),
  },
  methods: {
    removeCountry(item) {
      this.commercialZone.country_ids = this.commercialZone.country_ids.filter(
        (country) => country !== item.id
      );
      this.updateCommercialZone();
    },
    updateCommercialZone() {
      this.sendMutation(
        "updated",
        "commercial zone",
        UPDATE_COMMERCIAL_ZONE,
        this.commercialZone
      );
    },
    loadZone() {
      this.zoneId = this.$route.params.zone_id;
      this.commercialZone = this.getCommercialZoneById(this.zoneId);
      if (this.commercialZones.length > 0 && !this.commercialZone)
        this.$router.replace({
          name: "commercialZone",
          params: { zone_id: this.commercialZones[0].id },
        });
    },
  },
  watch: {
    $route() {
      this.loadZone();
    },
    commercialZones() {
      this.loadZone();
    },
  },
  created() {
    this.loadZone();
  },
};
</script>

<style></style>
